export default [
  {
        path: "/report/account-balance",
        name: "account-balance-report",
        component: () => import("@/views/report/paymentaccount/PaymentAccountBalanceReport.vue"),
        meta: {
          pageTitle: "Account Balance Report",
          action: "view",
          resource: "account-balance-report",
          breadcrumb: [
            {
              text: "Report",
              active: true
            },
            {
              text: "Account Balance",
              active: true
            }
          ]
        }
      },
      {
        path: "/report/trxtype-summary",
        name: "trxtype-summary-report",
        component: () => import("@/views/report/paymentaccount/TrxTypeSummaryReport.vue"),
        meta: {
          pageTitle: "TrxType Summary Report",
          action: "view",
          resource: "trxtype-summary-report",
          breadcrumb: [
            {
              text: "Report",
              active: true
            },
            {
              text: "TrxType Summary",
              active: true
            }
          ]
        }
      },
      {
        path: "/report/account-group",
        name: "account-group-report",
        component: () => import("@/views/report/paymentaccount/PaymentAccountGroupReport.vue"),
        meta: {
          pageTitle: "Account Group Report",
          action: "view",
          resource: "account-group-report",
          breadcrumb: [
            {
              text: "Report",
              active: true
            },
            {
              text: "Account Group",
              active: true
            }
          ]
        }
      },
      {
        path: "/report/agent-performance-summary/:agentCode?",
        props: true,
        name: "agent-performance-summary",
        component: () => import("@/views/report/agent/AgentPerformanceSummary.vue"),
        meta: {
          pageTitle: "Agent Performance Report",
          action: "view",
          resource: "agent-performance-summary",
          breadcrumb: [
            {
              text: "Report",
              active: true
            },
            {
              text: "Agent Performance Summary",
              active: true
            }
          ]
        }
      }
];
